import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

/**
 * Per-session anonymous participant identity. Stored in sessionStorage so
 * closing the tab drops the identity entirely (strict anonymity — the
 * participant is identifiable across reloads but not across sessions).
 *
 * Returns the participantId string for the given session code, creating one
 * on first call.
 */
export function useLiveParticipantId(code) {
  const key = code ? `liveParticipant:${code}` : null;

  const [participantId] = useState(() => {
    if (!key || typeof sessionStorage === 'undefined') return null;
    const existing = sessionStorage.getItem(key);
    if (existing) return existing;
    const fresh = uuidv4();
    sessionStorage.setItem(key, fresh);
    return fresh;
  });

  return participantId;
}
